import { createContext, useRef, useCallback, useMemo } from "react";
import useInputType from "../components/display-lists/inputTypes";

export const MultipartFormContext = createContext();

export const MultipartFormContextProvider = ({ type, children }) => {
  const { color } = useInputType(type) || {};
  const formBottomRef = useRef();

  const goToBottom = useCallback(() => {
    if (!formBottomRef.current) {
      return;
    }
    formBottomRef.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest"
    });
  }, []);

  const contextValue = useMemo(
    () => ({ color, formBottomRef, goToBottom }),
    [color, goToBottom]
  );

  return (
    <MultipartFormContext.Provider value={contextValue}>
      {children}
    </MultipartFormContext.Provider>
  );
};
